export default __webpack_public_path__ + "static/media/matching_2.e786d887.png";